import { render, staticRenderFns } from "./s-widget@.vue?vue&type=template&id=3e0bc3b3&"
import script from "./s-widget@.vue?vue&type=script&lang=ts&"
export * from "./s-widget@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports